/*global $:false */
'use strict';

angular.module('bringgApp.filters').filter('userImage', () => {
	return function (user) {
		return user?.profile_image || '/images/avatar.png';
	};
});
